import { useMutation } from '@tanstack/react-query';
import { apiClient } from 'api';
import { useToast } from 'hooks/useToast';

interface BulkInviteResponse {
  message: string;
  data: { Email: string; Fullname: string }[];
}

/**
 * Hook to invite candidates in bulk via file upload using React Query mutation
 */
export const useInviteBulkCandidates = () => {
  const { openToast } = useToast();

  return useMutation({
    mutationFn: async ({ assessmentId, file }: { assessmentId: string; file: File }) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await apiClient.post<BulkInviteResponse>(
        `/assessment/invite-bulk-candidates/${assessmentId}/`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      return response.data;
    },
    onSuccess: () => {
      openToast({
        show: true,
        heading: 'Success',
        text: 'Candidates invited successfully',
        type: 'success',
        timeOut: 5000,
      });
    },
    onError: (err: any) => {
      const errorMessage = err?.response?.data?.message || 'Failed to invite candidates';
      openToast({
        show: true,
        heading: 'Sorry',
        text: errorMessage,
        type: 'error',
        timeOut: 5000,
      });
    },
  });
};